import { useEffect, useRef } from 'react'
import clsx from 'clsx'

const CONTENT_HEIGHT_CLASS = 'match-height-content'

export const useManageLogOriginalRoute = (isDataLoading: boolean) => {
    const maxContentHeight = useRef(0)

    useEffect(() => {
        if (isDataLoading) {
            return
        }

        const cells = document.querySelectorAll(`.match-height-content`)
        let maxHeight = 0

        cells.forEach((cell) => {
            const height = cell.scrollHeight
            if (height > maxHeight) maxHeight = height
        })

        maxContentHeight.current = maxHeight
    }, [isDataLoading])

    const getElementAttributes = ({ className, isOriginalTrip }: { className?: string; isOriginalTrip: boolean }) => ({
        className: clsx(className, {
            [CONTENT_HEIGHT_CLASS]: isOriginalTrip,
        }),
        style: maxContentHeight.current ? { height: `${maxContentHeight.current}px` } : {},
    })

    return {
        getElementAttributes,
    }
}
